import React from 'react';
import './TextImageModule.css';

interface TextImageModuleProps {
  imagePosition?: 'left' | 'right';
  preHeading?: string;
  title: string;
  description: string;
  imageSrc: string;
  imageAlt: string;
}

const TextImageModule: React.FC<TextImageModuleProps> = ({
  imagePosition = 'left',
  preHeading,
  title,
  description,
  imageSrc,
  imageAlt,
}) => {
  return (
    <section className={`text-image-module ${imagePosition}`}>
      <div className="text-image-container">
        {/* Image Section */}
        <div className="media-section">
          <div className="img-zoom-wrapper">
            <div
              className="image-blur-wrapper"
              style={{
                backgroundImage: `url(${imageSrc})`,
                aspectRatio: '1360 / 765',
              }}
            >
              <picture className="responsive-image">
                <img
                  alt={imageAlt}
                  width="1360"
                  height="765"
                  src={imageSrc}
                  className="main-image"
                  style={{ aspectRatio: 'inherit' }}
                />
              </picture>
            </div>
          </div>
        </div>

        {/* Content Section */}
        <div className="content-section">
          <div className="content-inner">
            <div className="text-wrapper">
              {preHeading && (
                <p className="pre-heading">{preHeading}</p>
              )}
              <h2 className="section-title">{title}</h2>
              <p className="section-description">{description}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TextImageModule;
